module.exports = __webpack_public_path__ + "AngularPostit.svg?ca5d34abdd6d6e9b6d7dbbf1b8c6fb2c";